import { Box } from '@material-ui/core'
import DateRangerPicker, { ISelectDate } from 'components/DateRangerPicker'
import { useStyles } from './styles'

interface IResponsiveDateRangerPickerProps {
  startDate: Date
  endDate: Date
  onSelectedDate: (params: ISelectDate) => void
  title?: string
  isScheduledDate?: boolean
}

const ResponsiveDateRangerPicker = ({
  startDate,
  endDate,
  onSelectedDate,
  title,
  isScheduledDate
}: IResponsiveDateRangerPickerProps) => {
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <DateRangerPicker
        startDate={startDate}
        endDate={endDate}
        onSelectedDate={onSelectedDate}
        title={title}
        isScheduledDate={isScheduledDate}
        classContainer={classes.datePicker}
      />
    </Box>
  )
}

export default ResponsiveDateRangerPicker
